declare global {
  interface Window {
    __takeStudioInvitationToken?: () => string
  }
}

/** Consume the token captured by the inline invitation bootstrap. */
export function takeInitialInvitationToken(): string {
  return window.__takeStudioInvitationToken?.() ?? ''
}

export function protectInvitationReferrer(): void {
  if (document.getElementById('studio-invitation-referrer'))
    return
  const policy = document.createElement('meta')
  policy.id = 'studio-invitation-referrer'
  policy.name = 'referrer'
  policy.content = 'no-referrer'
  document.head.append(policy)
}

/** Restore normal document behavior when leaving the invitation route. */
export function clearInvitationBootstrap(): void {
  delete window.__takeStudioInvitationToken
  const policy = document.getElementById('studio-invitation-referrer')
  if (policy instanceof HTMLMetaElement) {
    // Removing a meta element alone does not reset the document's active policy.
    // Restore the app's existing public/_headers policy for subsequent SPA pages.
    policy.content = 'strict-origin-when-cross-origin'
    policy.remove()
  }
}
